import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import { getToken } from '@/utils/auth'

/* Layout */
import layout from '@/layout'

// 公共路由
export const constantRoutes = [
  {
    path: '',
    component: layout,
    // redirect: 'index',
    children: [
      {
        path: '',
        component: () => import('@/views/index'),
        /*
        meta: {
          requiresAuth: true
         },*/
        name: '首页',
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
  },
  {
    path: '/password',
    name: 'password',
    component: () => import('@/views/password'),

  },
  {
    path: '/editPassword',
    name: 'editPassword',
    component: () => import('@/views/editPassword'),

  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: 'campus',
        component: () => import('@/views/campus'),
        name: '校园招聘'
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: 'society',
        component: () => import('@/views/society'),
        name: '社会招聘'
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: 'highlevel',
        component: () => import('@/views/highlevel'),
        name: '高层次人才招聘'
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: 'hospital',
        component: () => import('@/views/hospital'),
        name: '医院概况'
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/activityList',
        name: '活动列表',
        component: () => import('@/views/activityList'),
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/announceList',
        name: '公告列表',
        component: () => import('@/views/announceList'),
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/positionList',
        name: '职位列表',
        component: () => import('@/views/positionList'),
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/activityDetail/:id',
        name: '活动详情页',
        component: () => import('@/views/activityDetail'),
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/announceDetail/:id',
        name: '公告详情页',
        component: () => import('@/views/announceDetail'),
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/positionDetail/:id',
        name: '职位详情页',
        component: () => import('@/views/positionDetail'),
      }
    ]
  },
  {
    path: '/',
    component: layout,
    children: [
      {
        path: '/user',
        name: '个人中心',
        // redirect:'/user/profile',
        meta: {
          requiresAuth: true
         },
        component: () => import('@/views/user/index'),
        // children: [
        //   {
        //     path: 'profile',   //注意 前面不能有 /
        //     name: '个人中心-基本信息',
        //     component: () => import('@/views/user/profile'),
        //   },
        //   {
        //     path: 'addEducation',   //注意 前面不能有
        //     name: '个人中心-添加教育经历',
        //     component: () => import('@/views/user/addEducation'),
        //   }
        // ]
      }
    ]
  },
  {
    path: '',
    component: layout,
    children: [
      {
        path: '/preview',
        name: '我的简历',
        meta: {
          requiresAuth: true
         },
        component: () => import('@/views/user/preview'),
      }
    ]
  },
  {
    path: '/',
    component: layout,
    children: [
      {
        path: '/process',
        name: '投递进程',
        meta: {
          requiresAuth: true
         },
        component: () => import('@/views/process'),
      }
    ]
  },
  {
    path: '/',
    component: layout,
    children: [
      {
        path: '/privacy',
        name: '隐私政策',
        meta: {
          requiresAuth: true
         },
        component: () => import('@/views/privacy'),
      }
    ]
  },
  {
    path: '/',
    component: layout,
    children: [
      {
        path: '/complaint',
        name: '投诉反馈',
        meta: {
          requiresAuth: true
         },
        component: () => import('@/views/complaint'),
      }
    ]
  },

];

const router = new Router({
  mode: 'history', // 去掉url中的#
  routes: constantRoutes
});

//注册全局钩子用来拦截导航
// router.beforeEach((to, from, next) => {
//   //获取cookie里面的token
//
//   let token = getToken();
//   //判断要去的路由有没有requiresAuth
//   if (to.meta.requiresAuth) {
//     if (token) {
//       if (to.path === '/login') {
//         next({ path: '/' })
//       }
//       next();
//     } else {
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath } // 将刚刚要去的路由path作为参数，方便登录成功后直接跳转到该路由
//       });
//     }
//   } else {
//     next();
//   }
// });
export default router;






// WEBPACK FOOTER //
// ./src/router/index.js